
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  width:100%;
  padding:1rem 0;
}

  @media (min-width: 768px){:host{
    padding:0
}
  }

.utility-nav--wrapper{
  display:flex;
  background-color:var(--brand-primary-3);
  padding:1rem 0;
  width:100%;
}

@media (min-width: 768px){

.utility-nav--wrapper{
    background-color:var(--brand-secondary-3);
    padding:0
}
  }

.utility-nav{
  display:flex;
  background-color:var(--brand-primary-3);
  justify-content:flex-start;
  width:100%;
  flex-direction:column;
  row-gap:2.5rem;
  font-family:var(--ff-dmsans) !important;
}

@media (min-width: 1024px){

.utility-nav{
    column-gap:1.25em
}
  }

@media (min-width: 768px){

.utility-nav{
    justify-content:flex-end;
    background-color:var(--brand-secondary-3);
    align-items:center;
    flex-direction:row;
    align-items:center;
    margin:0 auto;
    row-gap:0
}
  }

se-container{
  display:flex;
  width:100%;
}

slot[name='translate']{
  display:flex;
  height:100%;
  position:relative;
}

slot[name='utility']::slotted(*){
  font-size:var(--fs-sm);
}
`;